<script>
    import _debounce from 'lodash-es/debounce';

    import { search } from '../util/search';

    let userInput = '';

    function onFormSubmit() {
        debouncedOnInputChange.cancel();
        onInputChange();
    }

    function onInputChange() {
        search.updateFulltextSearch(userInput);
    }

    const debouncedOnInputChange = _debounce(onInputChange, 400);

</script>

<div class="search">
    <form class="search-bar" action="." on:submit|preventDefault={onFormSubmit}>
        <label for="faq-search-input" class="sr-only">FAQ durchsuchen</label>
        <input
            type="text"
            class="search-input"
            name="faq-search-input"
            id="faq-search-input"
            bind:value={userInput}
            on:input={debouncedOnInputChange}
            on:change={onFormSubmit}
        />
        <button type="submit" class="button is-style-ghost--search-retractable">
            <span> FAQ durchsuchen </span>
        </button>
    </form>
</div>
